export default () => ({
	status: 'closed',
	loading: {

	},
	cart: null,
	cartProducts: null,
	parts: JSON.parse(localStorage.getItem('CartContent')) || [],
	fullParts: []
})
